import { AnimationSpine } from 'core/display/spines/AnimationSpine'

export default class makeAnimationSpine extends PIXI.Container{
  constructor(data) {
    super()
    this.addChild(new AnimationSpine(data))
  }
}
